import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { queryClient } from '@/app/query-client'
import { router } from '@/app/router'
import { SessionGate } from '@/app/session-gate'
import '@/styles/index.css'

// /settings is an internal web tool with its own login; it must not wait for a native session.
const needsNativeSession = !/\/settings(\/|$)/.test(window.location.pathname)
const app = <RouterProvider router={router} />

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {needsNativeSession ? <SessionGate>{app}</SessionGate> : app}
    </QueryClientProvider>
  </StrictMode>,
)
